import { useEffect, useMemo, useRef } from 'react'
import { useSearchParams } from 'react-router'
import { cn } from '../../../@/lib/utils'
import { UserAvatar } from '../../users/UserAvatar'
import { CommentContent } from '../comment/CommentContent'
import { PaginatedComment } from '../types'
import { ActivityItemHeader } from './ActivityItemHeader'
import { ActivityEventItemType } from './ActivityTimeline'

export function ChildComment({ comment }: { comment: PaginatedComment['comment'] }) {
  const ref = useRef<HTMLDivElement>(null)
  const [searchParams] = useSearchParams()
  const highlightedCommentId = useMemo(() => searchParams.get('commentId') ?? '', [searchParams])

  const isHighlighted = useMemo(
    () => highlightedCommentId === comment.id,
    [comment.id, highlightedCommentId],
  )

  useEffect(() => {
    if (isHighlighted) {
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const timeline = ref.current
        setTimeout(() => timeline.classList.add('bg-white'), 3000)
      }
    }
  }, [isHighlighted])
  return (
    <div className="py-1">
      <div className="flex items-center gap-2">
        <UserAvatar user={comment.author} />
        <div className="w-full flex-1 py-1.5">
          <ActivityItemHeader
            action="replied"
            name={`${comment.author.firstName || ''} ${comment.author.lastName || ''}`}
            time={comment.createdAt}
            type={ActivityEventItemType.COMMENT}
          />
        </div>
      </div>
      <div
        ref={ref}
        className={cn(
          'p-2 ms-8 py-1 my-1 rounded text-sm ',
          isHighlighted && 'bg-blue-2 transition-colors duration-[2000ms]',
        )}
      >
        <CommentContent comment={comment} />
      </div>
    </div>
  )
}
